export class TsError extends Error {
    constructor(message?: string) {
        super(message); // 'Error' breaks prototype chain here
        this.name = 'TsError';
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
}
